module.exports = __webpack_public_path__ + "static/media/loadingdark.22806429.gif";